// assets/reorder-master-auto.js (Reorder Master: hide prices only)
(function () {
  // Only run once per page load
  if (window.__wrwReorderMasterHidePrices) return;
  window.__wrwReorderMasterHidePrices = true;

  const DEBUG = false;
  const log = (...args) => { if (DEBUG) console.log('[WRW ReorderMaster]', ...args); };

  /**
   * Goal:
   * Keep the Reorder Master popup fully functional,
   * but hide any visible pricing inside the popup only.
   *
   * No click interception.
   * No redirect.
   * No cart manipulation.
   */

  function injectHidePriceCSS() {
    if (document.getElementById('wrw-rm-hide-price-styles')) return;

    const style = document.createElement('style');
    style.id = 'wrw-rm-hide-price-styles';
    style.textContent = `
      /* Scope strictly to the Reorder Master modal */
      #hulkapp_reorder_master [class*="price" i],
      #hulkapp_reorder_master [id*="price" i],
      #hulkapp_reorder_master [data-price],
      #hulkapp_reorder_master .money,
      #hulkapp_reorder_master .Money,
      #hulkapp_reorder_master .hulk_price,
      #hulkapp_reorder_master .hulk-price,
      #hulkapp_reorder_master .hulk_cart_item_price,
      #hulkapp_reorder_master .hulk_cart__item_price,
      #hulkapp_reorder_master .hulk_cart_total,
      #hulkapp_reorder_master .hulk_cart__total,
      #hulkapp_reorder_master .hulk_subtotal,
      #hulkapp_reorder_master .hulk_sub_total,
      #hulkapp_reorder_master .hulk_total,
      #hulkapp_reorder_master .hulk_total_price,
      #hulkapp_reorder_master .hulk_total-price {
        display: none !important;
        visibility: hidden !important;
        opacity: 0 !important;
      }
    `;

    document.head.appendChild(style);
    log('Injected price-hiding CSS for Reorder Master modal');
  }

  // Inject immediately
  injectHidePriceCSS();

  // Light observer in case Hulk injects modal after page load
  const observer = new MutationObserver(() => {
    // Only act when the modal is in the DOM
    if (document.getElementById('hulkapp_reorder_master')) {
      injectHidePriceCSS();
    }
  });

  try {
    observer.observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {
    // no-op
  }
})();